import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownLight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.92431 7.66615C4.15221 7.44016 4.51661 7.44536 4.73823 7.67776L12 15.293L19.2618 7.67776C19.4834 7.44536 19.8478 7.44016 20.0757 7.66615C20.3036 7.89215 20.3087 8.26375 20.0871 8.49616L12.7745 16.1647C12.6744 16.2697 12.5544 16.3543 12.4215 16.4121C12.2884 16.47 12.1451 16.5 12 16.5C11.8549 16.5 11.7116 16.47 11.5785 16.4121C11.4456 16.3543 11.3259 16.2701 11.2258 16.165L3.91293 8.49616C3.69132 8.26375 3.69641 7.89215 3.92431 7.66615Z"
	})
});
export { SvgChevronDownLight as ReactComponent };
